// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Inter:wght@300;400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AILiveShow.css */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  overflow: hidden;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  background: #0a0f1c;
  color: #ffffff;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.ai-live-show {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  padding: 1vh;
  background: #0a0f1c;
}

/* Header - FIXED 20% of screen */
.show-header {
  background: rgba(10, 15, 28, 0.95);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
  height: 20vh; /* Fixed 10% of screen */
  flex-shrink: 0;
}

.event-banner {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 23%; /* 🎯 fokus ke area judul */
  transition: object-position 0.8s ease;
}

.ai-live-show.banner-full .banner-image {
  object-position: center top;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 2vh;
}

.banner-overlay h1 {
  font-family: 'Montserrat', sans-serif;
  font-size: 4.5vh; /* Dynamic font size */
  font-weight: 800;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 1vh;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.8);
  line-height: 1.2;
}

.event-theme {
  font-family: 'Montserrat', sans-serif;
  font-size: 3vh; /* Dynamic font size */
  font-weight: 600;
  color: #00d4ff;
  letter-spacing: 0.05em;
  max-width: 90%;
  line-height: 1.3;
  text-shadow: 0 2px 8px rgba(0, 212, 255, 0.4);
  margin-bottom: 1vh;
}

.last-updated {
  font-size: 1.8vh;
  color: #94a3b8;
  background: rgba(0, 0, 0, 0.5);
  padding: 0.8vh 2vh;
  border-radius: 20px;
  margin-top: 1vh;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* Main Content - FILLS 65% of screen */
.show-main {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1vh 0;
  min-height: 0; /* Important for flex sizing */
}

.comments-section {
  background: rgba(20, 25, 40, 0.95);
  border-radius: 16px;
  border: 1px solid rgba(0, 212, 255, 0.15);
  width: 95%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
}

.comments-header {
  padding: 1.5vh 2vh;
  border-bottom: 2px solid rgba(0, 212, 255, 0.2);
  background: rgba(15, 20, 35, 0.9);
  border-radius: 16px 16px 0 0;
  flex-shrink: 0;
}

.comments-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.comments-title h2 {
  font-family: 'Montserrat', sans-serif;
  font-size: 3.5vh;
  color: #ffffff;
  font-weight: 700;
}

.live-status {
  background: rgba(255, 0, 0, 0.15);
  color: #ff4444;
  padding: 0.8vh 1.8vh;
  border-radius: 20px;
  font-size: 2vh;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.8vh;
  border: 1px solid rgba(255, 0, 0, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.pulse-dot {
  width: 1.2vh;
  height: 1.2vh;
  background: #ff4444;
  border-radius: 50%;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* Comments Display - FILLS AVAILABLE SPACE */
.comments-display {
  flex: 1 1;
  padding: 2vh;
  display: flex;
  flex-direction: column;
  min-height: 0; /* Important for flex sizing */
  overflow: hidden;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 4vh;
}

.empty-icon {
  font-size: 8vh;
  margin-bottom: 2vh;
  opacity: 0.5;
}

.empty-state h3 {
  font-family: 'Montserrat', sans-serif;
  font-size: 3.5vh;
  color: #ffffff;
  margin-bottom: 1vh;
  font-weight: 600;
}

.empty-state p {
  font-size: 2.2vh;
  color: #8a94a6;
  margin-bottom: 2vh;
}

.waiting-message {
  font-size: 2vh;
  color: #00d4ff;
  display: flex;
  align-items: center;
  gap: 1vh;
  margin-top: 2vh;
  padding: 1.5vh 2.5vh;
  background: rgba(0, 212, 255, 0.1);
  border-radius: 12px;
  border: 1px solid rgba(0, 212, 255, 0.2);
}

.waiting-icon {
  font-size: 2.5vh;
  animation: pulse 2s infinite;
}

/* Comment Display Container */
.comment-display-container {
  height: 100%;
  width: 85%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 7.5%;
}

.comment-card {
  background: linear-gradient(135deg, rgba(25, 30, 45, 0.95) 0%, rgba(15, 20, 35, 0.95) 100%);
  border-radius: 16px;
  padding: 3vh;
  border: 1px solid rgba(0, 212, 255, 0.25);
  width: 100%;
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5);
}

.comment-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 6px;
  height: 100%;
  background: linear-gradient(180deg, #0066cc 0%, #00d4ff 100%);
}

.comment-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2vh;
  padding-bottom: 1.5vh;
  border-bottom: 1px solid rgba(0, 212, 255, 0.2);
  flex-shrink: 0;
}

.meta-left {
  display: flex;
  align-items: center;
  gap: 1.5vh;
}

.comment-type {
  font-size: 1.8vh;
  font-weight: 600;
  color: #00d4ff;
  background: rgba(0, 212, 255, 0.1);
  padding: 0.8vh 1.5vh;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 0.8vh;
}

.meta-right {
  font-size: 1.8vh;
  color: #8a94a6;
  font-family: 'Montserrat', sans-serif;
}

.comment-content {
  flex: 1 1;
  font-size: 3.5vh; /* Large for TV viewing */
  line-height: 1.4;
  color: #ffffff;
  font-weight: 400;
  overflow-y: auto; /* Allow scroll only inside content if needed */
  padding: 1vh;
  display: flex;
  flex-direction: column;
}

.comment-content::-webkit-scrollbar {
  width: 8px;
}

.comment-content::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.comment-content::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #0066cc 0%, #00a3ff 100%);
  border-radius: 4px;
}

/* HTML Content Styling */
.comment-content h1,
.comment-content h2,
.comment-content h3 {
  font-family: 'Montserrat', sans-serif;
  margin-bottom: 1vh;
  color: #00d4ff;
}

.comment-content p {
  margin-bottom: 1.5vh;
  line-height: 1.5;
}

.comment-content ul,
.comment-content ol {
  margin-left: 2vh;
  margin-bottom: 1.5vh;
}

.comment-content li {
  margin-bottom: 0.8vh;
  line-height: 1.4;
}

.comment-content strong {
  color: #00ff88;
  font-weight: 700;
}

.comment-content em {
  color: #ffd700;
  font-style: italic;
}

/* Footer - FIXED 10% of screen */
.show-footer {
  background: rgba(10, 15, 28, 0.95);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 1.2vh 2vh;
  height: 5vh; /* Fixed 10% of screen */
  min-height: 60px;
  flex-shrink: 0;
  margin-top: 1vh;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.footer-left {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.footer-logo {
  font-family: 'Montserrat', sans-serif;
  font-size: 2vh;
  font-weight: 700;
  color: #00d4ff;
  margin-bottom: 0.3vh;
}

.footer-theme {
  font-size: 1.5vh;
  color: #8a94a6;
  font-style: italic;
}

.footer-center {
  display: flex;
  align-items: center;
  gap: 1vh;
}

.refresh-info {
  font-size: 1.5vh;
  color: #94a3b8;
  display: flex;
  align-items: center;
  gap: 0.8vh;
  background: rgba(0, 0, 0, 0.3);
  padding: 0.8vh 1.5vh;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.refresh-icon {
  font-size: 1.8vh;
}

.footer-right .footer-meta {
  display: flex;
  gap: 1vh;
  font-size: 1.3vh;
  color: #8a94a6;
  font-weight: 500;
}

/* TV Optimizations */
@media (min-aspect-ratio: 16/9) {
  /* For wider screens (like 80" 4K TV) */
  .comment-content {
    font-size: 4vh;
  }
  
  .banner-overlay h1 {
    font-size: 5vh;
  }
  
  .event-theme {
    font-size: 3.5vh;
  }
}

@media (max-aspect-ratio: 4/3) {
  /* For taller screens */
  .comment-content {
    font-size: 3vh;
  }
  
  .banner-overlay h1 {
    font-size: 4vh;
  }
  
  .event-theme {
    font-size: 2.5vh;
  }
}

/* Banner Fullscreen Mode */
.ai-live-show.banner-full .show-header {
  height: calc(100vh - 2vh);
  transition: height 0.8s ease-in-out;
}

.ai-live-show.banner-full .show-footer {
  display: none;
}

.show-header {
  transition: height 0.8s ease-in-out;
}

/* Hide Main Content Smoothly */
.show-main.hidden {
  opacity: 0;
  transform: scale(0.96);
  pointer-events: none;
  transition: all 0.6s ease;
}

.show-main {
  transition: all 0.6s ease;
}

/* ============================= */
/* FINAL PROMPT MODE */
/* ============================= */

.comment-card.final-mode {
  height: auto;        /* ✅ BIAR NGIKUTI ISI */
  min-height: 100%;    /* tetap penuh layar */
  max-height: none;
  justify-content: flex-start;
}
.comment-card.final-mode::before {
  background: linear-gradient(180deg, #00ff88 0%, #00d4ff 100%);
}

/* Content khusus final */
.comment-content.final-content {
  overflow: visible; /* ❌ NO SCROLL */
  font-size: 2.6vh; /* Lebih kecil supaya muat */
  line-height: 1.45;
  justify-content: center;
}

.final-prompt h3 {
  font-size: 3.2vh;
  margin-bottom: 2vh;
  text-align: center;
}

.final-prompt p,
.final-prompt li {
  font-size: 2.4vh;
}

.final-prompt ol {
  margin-left: 2vh;
}

.final-prompt li {
  margin-bottom: 1vh;
}

.final-prompt .constraints {
  margin-top: 2vh;
  padding-top: 1.5vh;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}

.final-prompt .output-note {
  margin-top: 2vh;
  text-align: center;
  font-size: 2.3vh;
  color: #00ff88;
}

.comment-card.final-mode {
  animation: finalReveal 0.8s ease-out;
}

@keyframes finalReveal {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ailiveshow/AILiveShow.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAGnB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mEAAmE;EACnE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,kCAAkC;EAClC,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,YAAY,EAAE,wBAAwB;EACtC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B,EAAE,2BAA2B;EACxD,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,gBAAgB,EAAE,sBAAsB;EACxC,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,cAAc,EAAE,sBAAsB;EACtC,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;AAC5C;;AAEA,uCAAuC;AACvC;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,aAAa,EAAE,8BAA8B;AAC/C;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,iCAAiC;EACjC,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,6CAA6C;AAC7C;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,8BAA8B;EAC7C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,2FAA2F;EAC3F,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,gBAAgB,EAAE,yBAAyB;EAC3C,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB,EAAE,+CAA+C;EACjE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;;;EAGE,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,kCAAkC;EAClC,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,WAAW,EAAE,wBAAwB;EACrC,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,uCAAuC;EACvC;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,uBAAuB;EACvB;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;AACrC;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC,sBAAsB;AACtB,kCAAkC;;AAElC;EACE,YAAY,SAAS,uBAAuB;EAC5C,gBAAgB,KAAK,sBAAsB;EAC3C,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,6DAA6D;AAC/D;;AAEA,yBAAyB;AACzB;EACE,iBAAiB,EAAE,gBAAgB;EACnC,gBAAgB,EAAE,4BAA4B;EAC9C,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":["/* AILiveShow.css */\r\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Inter:wght@300;400;500;600&display=swap');\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml, body {\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\nbody {\r\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\r\n  background: #0a0f1c;\r\n  color: #ffffff;\r\n  height: 100vh;\r\n  width: 100vw;\r\n  overflow: hidden;\r\n}\r\n\r\n.ai-live-show {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100vh;\r\n  width: 100vw;\r\n  padding: 1vh;\r\n  background: #0a0f1c;\r\n}\r\n\r\n/* Header - FIXED 20% of screen */\r\n.show-header {\r\n  background: rgba(10, 15, 28, 0.95);\r\n  border-radius: 16px;\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  overflow: hidden;\r\n  height: 20vh; /* Fixed 10% of screen */\r\n  flex-shrink: 0;\r\n}\r\n\r\n.event-banner {\r\n  position: relative;\r\n  height: 100%;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.banner-image {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  object-position: center 23%; /* 🎯 fokus ke area judul */\r\n  transition: object-position 0.8s ease;\r\n}\r\n\r\n.ai-live-show.banner-full .banner-image {\r\n  object-position: center top;\r\n}\r\n\r\n.banner-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  padding: 2vh;\r\n}\r\n\r\n.banner-overlay h1 {\r\n  font-family: 'Montserrat', sans-serif;\r\n  font-size: 4.5vh; /* Dynamic font size */\r\n  font-weight: 800;\r\n  color: #ffffff;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.1em;\r\n  margin-bottom: 1vh;\r\n  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.8);\r\n  line-height: 1.2;\r\n}\r\n\r\n.event-theme {\r\n  font-family: 'Montserrat', sans-serif;\r\n  font-size: 3vh; /* Dynamic font size */\r\n  font-weight: 600;\r\n  color: #00d4ff;\r\n  letter-spacing: 0.05em;\r\n  max-width: 90%;\r\n  line-height: 1.3;\r\n  text-shadow: 0 2px 8px rgba(0, 212, 255, 0.4);\r\n  margin-bottom: 1vh;\r\n}\r\n\r\n.last-updated {\r\n  font-size: 1.8vh;\r\n  color: #94a3b8;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  padding: 0.8vh 2vh;\r\n  border-radius: 20px;\r\n  margin-top: 1vh;\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n/* Main Content - FILLS 65% of screen */\r\n.show-main {\r\n  flex: 1;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 1vh 0;\r\n  min-height: 0; /* Important for flex sizing */\r\n}\r\n\r\n.comments-section {\r\n  background: rgba(20, 25, 40, 0.95);\r\n  border-radius: 16px;\r\n  border: 1px solid rgba(0, 212, 255, 0.15);\r\n  width: 95%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.comments-header {\r\n  padding: 1.5vh 2vh;\r\n  border-bottom: 2px solid rgba(0, 212, 255, 0.2);\r\n  background: rgba(15, 20, 35, 0.9);\r\n  border-radius: 16px 16px 0 0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.comments-title {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.comments-title h2 {\r\n  font-family: 'Montserrat', sans-serif;\r\n  font-size: 3.5vh;\r\n  color: #ffffff;\r\n  font-weight: 700;\r\n}\r\n\r\n.live-status {\r\n  background: rgba(255, 0, 0, 0.15);\r\n  color: #ff4444;\r\n  padding: 0.8vh 1.8vh;\r\n  border-radius: 20px;\r\n  font-size: 2vh;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.8vh;\r\n  border: 1px solid rgba(255, 0, 0, 0.3);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.pulse-dot {\r\n  width: 1.2vh;\r\n  height: 1.2vh;\r\n  background: #ff4444;\r\n  border-radius: 50%;\r\n  animation: pulse 1.5s infinite;\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% { opacity: 1; }\r\n  50% { opacity: 0.5; }\r\n}\r\n\r\n/* Comments Display - FILLS AVAILABLE SPACE */\r\n.comments-display {\r\n  flex: 1;\r\n  padding: 2vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0; /* Important for flex sizing */\r\n  overflow: hidden;\r\n}\r\n\r\n.empty-state {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  text-align: center;\r\n  padding: 4vh;\r\n}\r\n\r\n.empty-icon {\r\n  font-size: 8vh;\r\n  margin-bottom: 2vh;\r\n  opacity: 0.5;\r\n}\r\n\r\n.empty-state h3 {\r\n  font-family: 'Montserrat', sans-serif;\r\n  font-size: 3.5vh;\r\n  color: #ffffff;\r\n  margin-bottom: 1vh;\r\n  font-weight: 600;\r\n}\r\n\r\n.empty-state p {\r\n  font-size: 2.2vh;\r\n  color: #8a94a6;\r\n  margin-bottom: 2vh;\r\n}\r\n\r\n.waiting-message {\r\n  font-size: 2vh;\r\n  color: #00d4ff;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1vh;\r\n  margin-top: 2vh;\r\n  padding: 1.5vh 2.5vh;\r\n  background: rgba(0, 212, 255, 0.1);\r\n  border-radius: 12px;\r\n  border: 1px solid rgba(0, 212, 255, 0.2);\r\n}\r\n\r\n.waiting-icon {\r\n  font-size: 2.5vh;\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n/* Comment Display Container */\r\n.comment-display-container {\r\n  height: 100%;\r\n  width: 85%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-left: 7.5%;\r\n}\r\n\r\n.comment-card {\r\n  background: linear-gradient(135deg, rgba(25, 30, 45, 0.95) 0%, rgba(15, 20, 35, 0.95) 100%);\r\n  border-radius: 16px;\r\n  padding: 3vh;\r\n  border: 1px solid rgba(0, 212, 255, 0.25);\r\n  width: 100%;\r\n  height: 100%;\r\n  max-height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.comment-card::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 6px;\r\n  height: 100%;\r\n  background: linear-gradient(180deg, #0066cc 0%, #00d4ff 100%);\r\n}\r\n\r\n.comment-meta {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 2vh;\r\n  padding-bottom: 1.5vh;\r\n  border-bottom: 1px solid rgba(0, 212, 255, 0.2);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.meta-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1.5vh;\r\n}\r\n\r\n.comment-type {\r\n  font-size: 1.8vh;\r\n  font-weight: 600;\r\n  color: #00d4ff;\r\n  background: rgba(0, 212, 255, 0.1);\r\n  padding: 0.8vh 1.5vh;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.8vh;\r\n}\r\n\r\n.meta-right {\r\n  font-size: 1.8vh;\r\n  color: #8a94a6;\r\n  font-family: 'Montserrat', sans-serif;\r\n}\r\n\r\n.comment-content {\r\n  flex: 1;\r\n  font-size: 3.5vh; /* Large for TV viewing */\r\n  line-height: 1.4;\r\n  color: #ffffff;\r\n  font-weight: 400;\r\n  overflow-y: auto; /* Allow scroll only inside content if needed */\r\n  padding: 1vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.comment-content::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.comment-content::-webkit-scrollbar-track {\r\n  background: rgba(0, 0, 0, 0.2);\r\n  border-radius: 4px;\r\n}\r\n\r\n.comment-content::-webkit-scrollbar-thumb {\r\n  background: linear-gradient(180deg, #0066cc 0%, #00a3ff 100%);\r\n  border-radius: 4px;\r\n}\r\n\r\n/* HTML Content Styling */\r\n.comment-content h1,\r\n.comment-content h2,\r\n.comment-content h3 {\r\n  font-family: 'Montserrat', sans-serif;\r\n  margin-bottom: 1vh;\r\n  color: #00d4ff;\r\n}\r\n\r\n.comment-content p {\r\n  margin-bottom: 1.5vh;\r\n  line-height: 1.5;\r\n}\r\n\r\n.comment-content ul,\r\n.comment-content ol {\r\n  margin-left: 2vh;\r\n  margin-bottom: 1.5vh;\r\n}\r\n\r\n.comment-content li {\r\n  margin-bottom: 0.8vh;\r\n  line-height: 1.4;\r\n}\r\n\r\n.comment-content strong {\r\n  color: #00ff88;\r\n  font-weight: 700;\r\n}\r\n\r\n.comment-content em {\r\n  color: #ffd700;\r\n  font-style: italic;\r\n}\r\n\r\n/* Footer - FIXED 10% of screen */\r\n.show-footer {\r\n  background: rgba(10, 15, 28, 0.95);\r\n  border-radius: 12px;\r\n  border: 1px solid rgba(255, 255, 255, 0.08);\r\n  padding: 1.2vh 2vh;\r\n  height: 5vh; /* Fixed 10% of screen */\r\n  min-height: 60px;\r\n  flex-shrink: 0;\r\n  margin-top: 1vh;\r\n}\r\n\r\n.footer-content {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  height: 100%;\r\n}\r\n\r\n.footer-left {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.footer-logo {\r\n  font-family: 'Montserrat', sans-serif;\r\n  font-size: 2vh;\r\n  font-weight: 700;\r\n  color: #00d4ff;\r\n  margin-bottom: 0.3vh;\r\n}\r\n\r\n.footer-theme {\r\n  font-size: 1.5vh;\r\n  color: #8a94a6;\r\n  font-style: italic;\r\n}\r\n\r\n.footer-center {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1vh;\r\n}\r\n\r\n.refresh-info {\r\n  font-size: 1.5vh;\r\n  color: #94a3b8;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.8vh;\r\n  background: rgba(0, 0, 0, 0.3);\r\n  padding: 0.8vh 1.5vh;\r\n  border-radius: 8px;\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.refresh-icon {\r\n  font-size: 1.8vh;\r\n}\r\n\r\n.footer-right .footer-meta {\r\n  display: flex;\r\n  gap: 1vh;\r\n  font-size: 1.3vh;\r\n  color: #8a94a6;\r\n  font-weight: 500;\r\n}\r\n\r\n/* TV Optimizations */\r\n@media (min-aspect-ratio: 16/9) {\r\n  /* For wider screens (like 80\" 4K TV) */\r\n  .comment-content {\r\n    font-size: 4vh;\r\n  }\r\n  \r\n  .banner-overlay h1 {\r\n    font-size: 5vh;\r\n  }\r\n  \r\n  .event-theme {\r\n    font-size: 3.5vh;\r\n  }\r\n}\r\n\r\n@media (max-aspect-ratio: 4/3) {\r\n  /* For taller screens */\r\n  .comment-content {\r\n    font-size: 3vh;\r\n  }\r\n  \r\n  .banner-overlay h1 {\r\n    font-size: 4vh;\r\n  }\r\n  \r\n  .event-theme {\r\n    font-size: 2.5vh;\r\n  }\r\n}\r\n\r\n/* Banner Fullscreen Mode */\r\n.ai-live-show.banner-full .show-header {\r\n  height: calc(100vh - 2vh);\r\n  transition: height 0.8s ease-in-out;\r\n}\r\n\r\n.ai-live-show.banner-full .show-footer {\r\n  display: none;\r\n}\r\n\r\n.show-header {\r\n  transition: height 0.8s ease-in-out;\r\n}\r\n\r\n/* Hide Main Content Smoothly */\r\n.show-main.hidden {\r\n  opacity: 0;\r\n  transform: scale(0.96);\r\n  pointer-events: none;\r\n  transition: all 0.6s ease;\r\n}\r\n\r\n.show-main {\r\n  transition: all 0.6s ease;\r\n}\r\n\r\n/* ============================= */\r\n/* FINAL PROMPT MODE */\r\n/* ============================= */\r\n\r\n.comment-card.final-mode {\r\n  height: auto;        /* ✅ BIAR NGIKUTI ISI */\r\n  min-height: 100%;    /* tetap penuh layar */\r\n  max-height: none;\r\n  justify-content: flex-start;\r\n}\r\n.comment-card.final-mode::before {\r\n  background: linear-gradient(180deg, #00ff88 0%, #00d4ff 100%);\r\n}\r\n\r\n/* Content khusus final */\r\n.comment-content.final-content {\r\n  overflow: visible; /* ❌ NO SCROLL */\r\n  font-size: 2.6vh; /* Lebih kecil supaya muat */\r\n  line-height: 1.45;\r\n  justify-content: center;\r\n}\r\n\r\n.final-prompt h3 {\r\n  font-size: 3.2vh;\r\n  margin-bottom: 2vh;\r\n  text-align: center;\r\n}\r\n\r\n.final-prompt p,\r\n.final-prompt li {\r\n  font-size: 2.4vh;\r\n}\r\n\r\n.final-prompt ol {\r\n  margin-left: 2vh;\r\n}\r\n\r\n.final-prompt li {\r\n  margin-bottom: 1vh;\r\n}\r\n\r\n.final-prompt .constraints {\r\n  margin-top: 2vh;\r\n  padding-top: 1.5vh;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\r\n}\r\n\r\n.final-prompt .output-note {\r\n  margin-top: 2vh;\r\n  text-align: center;\r\n  font-size: 2.3vh;\r\n  color: #00ff88;\r\n}\r\n\r\n.comment-card.final-mode {\r\n  animation: finalReveal 0.8s ease-out;\r\n}\r\n\r\n@keyframes finalReveal {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.96);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
